var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusRunningRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    cy: 48,
    cx: 48,
    strokeOpacity: "null",
    strokeWidth: "null",
    r: 48,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    cy: 48,
    cx: 48,
    strokeOpacity: "null",
    strokeWidth: "null",
    r: 34,
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    strokeOpacity: "null",
    strokeWidth: "null"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 48,
    cx: 48,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 48,
    cx: 48,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0f3c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.81181312,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M0 48a48 48 0 0 1-48 48V48Z",
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 5.12125984,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    cx: 48,
    cy: 48,
    r: 31.296
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 5.12125984,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    cx: 48,
    cy: 48,
    r: 16.696
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 5.12125984,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    cx: 48,
    cy: 48,
    r: 5.907
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusRunningRemote);
export default __webpack_public_path__ + "static/media/status-running-remote.482e6bdcf4a60d4ee04014720650cc42.svg";
export { ForwardRef as ReactComponent };